// extracted by mini-css-extract-plugin
export default {"wrapperRoot":"wrapperRoot--hyVWm","wrapperHeader":"wrapperHeader--NtJmO","label":"label--SuIek","hiddenComponent":"hiddenComponent--pjYhA","warningBorder":"warningBorder--gJt9u"};